/* Howler configs without the Howl instance */
export default {
  sfx_typeBlip: {
    src: [
      "/sfx/Blip-0.0_bip_3.1.wav"
    ],
    volume: 0.75
  },
  sfx_cursorMove: {
    src: ["/sfx/menu-move.mp3"],
    volume: 1
  },
  sfx_submitAction: {
    src: ["/sfx/submit.mp3"],
    volume: 1
  },
  sfx_submitMegaSuccess: {
    src: [
      "/sfx/sfx-mega-success.mp3"
    ],
    volume: 1
  },
  sfx_loopIterate: {
    src: ["/sfx/iterator.mp3"],
    volume: 1
  },
  sfx_Babuhm: {
    src: ["/sfx/baBuhm.mp3"]
  },
  sfx_fillHp: {
    src: ["/sfx/increase-xp.mp3"],
    volume: 1
  },
  sfx_popup: {
    src: ["/sfx/bell_up.mp3"],
    volume: 0.7
  },
  sfx_taunt: {
    src: ["/sfx/taunt.mp3"],
    volume: 1
  },
  sfx_jump: {
    src: ["/sfx/sfx-jump.mp3"],
    volume: 0.4
  },
  sfx_acceptBattle: {
    src: ["/sfx/shhhink-accepted--bit-crush-more-cresc.mp3"],
    volume: 0.4
  }
};

// //SFXs
// export const sfxBabum = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/baBuhm.mp3']
// });
//
// export const sfxTypeBlip = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/Blip-0.0_bip_3.1.wav'],
//     volume: 0.75
// });
//

//
// export const sfxSubmitAction = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/submit.mp3'],
//     volume: 1
// });
//
// export const sfxIterate = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/iterator.mp3'],
//     volume: 1
// });
//
// //Battle REQUESTs
//
// export const sfxBattleRequest = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/exclaim_up.mp3'],
//     volume: 1
// });
// export const sfxBattleRequestDenied = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/exclaim_down.mp3'],
//     volume: 1
// });
// // export const sfxBattleRequestAccepted = new Howl({
// //     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/shhhink-accepted--bit-crush-more-cresc.mp3'],
// //     volume: 1
// // });
//
//
// //Battle Results
// export const sfxBattleResultPopup = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/pod_open.mp3'],
//     volume: 0.4
// });
// export const sfxIncreaseXp = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/increase-xp.mp3'],
//     volume: 1
// });
// export const sfxLevelUp = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/reach-levelup.mp3'],
//     volume: 1
// });
//
//
// //Journal
// export const sfxJournalUpdate = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/bell_down.mp3'],
//     volume: 1
// });
//
// //Popup (onboarding popup)
// export const sfxPopup = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/bell_up.mp3'],
//     volume: 1
// });
//
//
// //Title
// export const sfxTitlePortal = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/speedup6.mp3'],
//     volume: 0.7
// });



// WEBPACK FOOTER //
// ./src/_audio/_sfx.js